<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'manage-image'"
    @hidden="$emit('onCloseModal')"
    @show="fetchCriteriaData"
  >
    <b-form @submit.prevent="onSubmitModal">
      <div class="row mb-1">
        <div class="col-12 p-0">
          <div class="information-header">
            {{ isEdit ? "Edit Criteria" : "Add Criteria" }}
          </div>
        </div>
      </div>
      <div class="modal-wrp mx-3">
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group :label="'Choose'" label-class="font-medium-5">
              <b-form-radio-group
                v-model="formData.criteriaType"
                :options="criteriaTypeOptions"
                :disabled="true"
                class="custom-radio-group bypass"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Priority'"
              label-for="priority"
              label-class="font-medium-5 required"
            >
              <b-form-input
                id="priority"
                v-model="formData.priority"
                :placeholder="'Input only number'"
                @input="onNumberInput($event, 'priority')"
                required
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Name'"
              label-for="name"
              label-class="font-medium-5 required"
            >
              <b-form-input
                id="name"
                v-model="formData.name"
                :placeholder="'ระบุ'"
                required
              />
            </b-form-group>
          </div>
        </div>
        <div
          class="row mb-2"
          :class="[{ 'd-none': formData.criteriaType == 1 }]"
        >
          <div class="col-12">
            <div>
              <label for="flag-option-tag">
                <span class="font-medium-5">{{ "Tag" }}</span>
              </label>
              <v-select
                id="flag-option-tag"
                v-model="formData.tag"
                multiple
                :options="optionData.tagList"
                class="tag-dropdown"
                :class="[{ bypass: isEdit }]"
              />
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group :label="'Point Mode'" label-class="font-medium-5">
              <b-form-radio-group
                v-model="formData.pointMode"
                :options="criteriaTypeOptions"
                :disabled="isEdit"
                class="custom-radio-group"
                :class="[{ bypass: isEdit }]"
              />
            </b-form-group>
          </div>
        </div>
        <div
          class="row mb-1"
          v-if="formData.pointMode !== 1 && formExchange.type == 6"
        >
          <div class="col-12">
            <input-spin
              :mode="isEdit ? 'disabled' : ''"
              v-model="formData.point"
              :numValue="Number(formData.point)"
              :addValue="formExchange.stepValue"
              :minValue="formExchange.minValue"
              :isInputDisabled="false"
              @update-number="updatePoint"
            />
          </div>
        </div>
        <div
          v-if="formData.pointMode !== 1 && formExchange.type != 6"
          class="row mb-1"
        >
          <div class="col-12">
            <b-form-group
              :label="'Point'"
              label-for="point"
              label-class="font-medium-5 required"
            >
              <b-form-input
                id="point"
                v-model="formData.point"
                :placeholder="'ระบุ'"
                required
                :disabled="isEdit"
                @input="onNumberInput($event, 'point')"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Note'"
              label-for="note"
              label-class="font-medium-5"
            >
              <b-form-input
                id="note"
                v-model="formData.note"
                :placeholder="'ระบุ'"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group :label="'Visibility'" label-class="font-medium-5">
              <b-form-radio-group
                v-model="formData.isVisible"
                :options="booleanTypeOptions"
                class="custom-radio-group"
                :disabled="isEdit"
                :class="[{ bypass: isEdit }]"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group :label="'Issuable'" label-class="font-medium-5">
              <b-form-radio-group
                v-model="formData.isIssuable"
                :options="booleanTypeOptions"
                class="custom-radio-group"
                :disabled="isEdit"
                :class="[{ bypass: isEdit }]"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <b-form-group :label="'Redeemable'" label-class="font-medium-5">
              <b-form-radio-group
                v-model="formData.isRedeemable"
                :options="booleanTypeOptions"
                class="custom-radio-group"
                :disabled="isEdit"
                :class="[{ bypass: isEdit }]"
              />
            </b-form-group>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="modal-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                v-if="formData.criteriaType != 1"
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button class="ml-1" type="submit" />
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>
import ImageMultipleUpload from "./ImageMultipleUpload.vue";
import useManageCriteriaListModal from "../../hooks/useManageCriteriaListModal";
import InputSpin from "@/views/components/input-spin/InputSpin.vue";

export default {
  components: { ImageMultipleUpload, InputSpin },
  props: {
    isEdit: { type: Boolean, default: false },
    formDataObj: { type: Object, default: {} },
  },

  setup(props) {
    const {
      formData,
      criteriaTypeOptions,
      booleanTypeOptions,
      optionData,
      fetchCriteriaData,
      onSubmitModal,
      onNumberInput,
      formExchange,
      updatePoint,
    } = useManageCriteriaListModal(props);

    return {
      formData,
      criteriaTypeOptions,
      booleanTypeOptions,
      optionData,
      fetchCriteriaData,
      onSubmitModal,
      onNumberInput,
      formExchange,
      updatePoint,
    };
  },
};
</script>
